import { StyleSheet } from "@react-pdf/renderer";

export const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 0,
    fontFamily: "Helvetica",
    fontSize: 10,
  },

  // Header Styles
  header: {
    backgroundColor: "#00195f",
    padding: 25,
    marginBottom: 20,
    color: "white",
  },
  headerContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  companySection: {
    flex: 1,
    paddingRight: 20,
  },
  companyName: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#f69e22",
    marginBottom: 8,
  },
  companyLogo: {
    maxHeight: 50,
    maxWidth: 120,
    objectFit: "contain",
    marginBottom: 10,
    backgroundColor: "white",
    padding: 5,
    borderRadius: 4,
  },
  companyDetails: {
    fontSize: 9,
    color: "#f8b04a",
    lineHeight: 1.4,
  },
  companyDetailItem: {
    marginBottom: 3,
  },

  invoiceSection: {
    alignItems: "flex-end",
    minWidth: 180,
  },
  invoiceTitle: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#f69e22",
    marginBottom: 12,
  },
  invoiceMeta: {
    backgroundColor: "rgba(255,255,255,0.15)",
    padding: 12,
    borderRadius: 4,
    border: "1px solid rgba(255,255,255,0.2)",
    minWidth: 160,
  },
  metaItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
    fontSize: 8,
  },
  metaLabel: {
    color: "rgba(255,255,255,0.9)",
    fontWeight: "normal",
  },
  metaValue: {
    color: "white",
    fontWeight: "bold",
    marginLeft: 8,
  },

  // Content Styles
  content: {
    padding: 20,
    flexGrow: 1,
  },

  // Billing Section
  billingSection: {
    flexDirection: "row",
    marginBottom: 25,
    gap: 20,
  },
  billToSection: {
    flex: 1,
  },
  paymentTermsSection: {
    flex: 1,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#00195f",
    marginBottom: 8,
    paddingBottom: 3,
    borderBottom: "2px solid #f69e22",
    textTransform: "uppercase",
  },
  infoCard: {
    backgroundColor: "#f8f9fb",
    padding: 15,
    borderRadius: 6,
    borderLeft: "4px solid #f69e22",
  },
  facilityName: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#00195f",
    marginBottom: 6,
  },
  infoItem: {
    flexDirection: "row",
    marginBottom: 3,
    fontSize: 9,
  },
  infoLabel: {
    color: "#6c757d",
    fontWeight: "normal",
    width: 80,
  },
  infoValue: {
    color: "#2c3e50",
    fontWeight: "bold",
    flex: 1,
  },

  // Table Styles
  itemsSection: {
    marginVertical: 20,
  },
  table: {
    display: "table",
    width: "auto",
    marginBottom: 15,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#00195f",
    color: "white",
    fontWeight: "bold",
    fontSize: 9,
    textTransform: "uppercase",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #e3e8ef",
    minHeight: 30,
    alignItems: "center",
  },
  tableRowEven: {
    backgroundColor: "#f8f9fb",
  },

  // Table Columns
  descriptionCol: {
    width: "45%",
    padding: 8,
  },
  quantityCol: {
    width: "15%",
    padding: 8,
    textAlign: "center",
  },
  priceCol: {
    width: "20%",
    padding: 8,
    textAlign: "right",
  },
  totalCol: {
    width: "20%",
    padding: 8,
    textAlign: "right",
  },

  itemDescription: {
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 2,
  },
  itemDetail: {
    fontSize: 8,
    color: "#6c757d",
  },

  // Totals Section
  totalsSection: {
    alignItems: "flex-end",
    marginTop: 20,
  },
  totalsTable: {
    minWidth: 200,
  },
  totalsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderBottom: "1px solid #e3e8ef",
  },
  totalsFinalRow: {
    backgroundColor: "#00195f",
    color: "white",
    fontWeight: "bold",
    fontSize: 11,
    paddingVertical: 10,
    paddingHorizontal: 15,
  },

  // Footer Styles
  footer: {
    backgroundColor: "#f8f9fb",
    padding: 20,
    borderTop: "3px solid #f69e22",
    marginTop: "auto",
  },
  footerContent: {
    flexDirection: "row",
    gap: 20,
  },
  footerSection: {
    flex: 1,
  },
  footerTitle: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#00195f",
    marginBottom: 8,
    textTransform: "uppercase",
  },
  footerCard: {
    backgroundColor: "white",
    padding: 12,
    borderRadius: 4,
    borderLeft: "3px solid #f69e22",
  },

  // Status Badge
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 10,
    fontSize: 7,
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  statusPaid: {
    backgroundColor: "#27ae60",
    color: "white",
  },
  statusPending: {
    backgroundColor: "#f69e22",
    color: "#001347",
  },
  statusOverdue: {
    backgroundColor: "#e74c3c",
    color: "white",
  },

  // Thank You Section
  thankYou: {
    textAlign: "center",
    marginTop: 25,
    padding: 15,
    backgroundColor: "#00195f",
    color: "white",
    borderRadius: 6,
  },
  thankYouText: {
    fontSize: 11,
    fontWeight: "bold",
  },

  // Utility Classes
  textBold: {
    fontWeight: "bold",
  },
  textCenter: {
    textAlign: "center",
  },
  textRight: {
    textAlign: "right",
  },
  mb5: {
    marginBottom: 5,
  },
  mb10: {
    marginBottom: 10,
  },
  mt10: {
    marginTop: 10,
  },
  mt20: {
    marginTop: 20,
  },
});
